// Global packages and components
import { Accordion, ContentEditor, Heading } from '~/components'

// Types
import type { PortableTextBlock } from '@portabletext/react'

/*
  FAQ accordions. The FAQPage schema is emitted as JSON-LD by the route, so
  there is no microdata here.
*/
const ProductFaqs = ({
  faqs,
}: {
  faqs: {
    question: string
    answer: PortableTextBlock[]
  }[]
}) => (
  <div className="container mb-16">
    <div className="mx-auto max-w-3xl">
      <Heading
        tag="h2"
        size="h4"
        className="text-center"
      >
        Questions
      </Heading>
      <Accordion>
        {faqs.map((faq, i) => (
          <Accordion.Section
            title={faq.question}
            className="mb-2"
            key={i}
          >
            {faq.answer && <ContentEditor content={faq.answer} />}
          </Accordion.Section>
        ))}
      </Accordion>
    </div>
  </div>
)

export default ProductFaqs
